import { z } from 'zod';
import { ModelFolderNameSchema } from './models.js';
export const DownloadStatusSchema = z.enum(['running', 'done', 'failed', 'cancelled']);
/** A download as the machine's agent reports it (untrusted: validated). */
export const DownloadSchema = z.object({
    id: z.string().max(64),
    fileName: z.string().max(255),
    folder: ModelFolderNameSchema,
    sizeBytes: z.number().int().min(0).nullable(),
    receivedBytes: z.number().int().min(0),
    status: DownloadStatusSchema,
    error: z.string().max(1000).nullable(),
    startedAt: z.string().max(64),
    finishedAt: z.string().max(64).nullable(),
});
export const StartDownloadRequestSchema = z.object({
    url: z.string().trim().min(1).max(2000),
    folder: ModelFolderNameSchema.optional(),
});
export const DownloadResponseSchema = z.object({ download: DownloadSchema });
export const DownloadsResponseSchema = z.object({ downloads: z.array(DownloadSchema).max(500) });
//# sourceMappingURL=downloads.js.map